<template>
  <v-app>
    <NavBar />
    <v-main class="white">
      <v-divider class="red darken-4 pt-1"></v-divider>
      <router-view
      :itemsLegislacao="itemsLegislacao">
      </router-view>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer";
import apiService from "./services/apiService";

export default {
  name: "App",
  components: {
    NavBar,
    Footer,
  },
  data: () => ({
    itemsLegislacao: null
  }),
  created() {
     apiService.getLegislacao().then((response) => {      
      // legislacao
      this.itemsLegislacao = response.data.listaLegislacao;    
      //console.log(this.itemsLegislacao)  
    });
  },
};
</script>

<style>
</style>
